import React from 'react';

export default function Footer(props) {
	return (
    <div className={"footer"}>
      <div className="left-footer">
        <h2>© {new Date().getFullYear()} Dynamoid, Inc</h2>
        <a href="/privacy">Privacy</a>
        <a href="/fcoi">FCOI policy</a>
      </div>

      <div>
        <h2>Oakland, CA</h2>
      </div>

      <div className="contact">
        <h2>510-646-1304</h2>
        <h2>info@dynamoid.com</h2>
      </div>
    </div>
  );
}
